import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export const useParentMessage = () => {
  const {
    token,
    setToken,
    stampTomador,
    setStampTomador,
    parentMessage,
    setParentMessage,
    parentMessageVersion,
  } = useAuth();

  useEffect(() => {

    const handleMessage = (event) => {

      const data = event.data;

      if (!data || data.type !== "TOKEN") return;

 
      const allowedOrigins = [
        "https://apichat.gemese.pt",
        "https://chat.gemese.pt",
        "https://portal.gemese.pt",
        "http://localhost:8000"
      ];

      const isLocalFileTest =
        process.env.NODE_ENV === "development" && event.origin === "null";

      if (!allowedOrigins.includes(event.origin) && !isLocalFileTest) {
        return;
      }

      if (typeof data.token !== "string" || !data.token.trim()) {
        return;
      }
	  
	   const receivedMessage =
        event.data.message ||
        event.data.mensagem ||
        event.data.MENSAGEM ||
        event.data.text ||
        null;


      setToken(data.token);
      setStampTomador(data.StampTomador || null);
	  setParentMessage(receivedMessage);
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);

  }, [setToken, setStampTomador]);
  
  
  
    const notifyParent = (payload) => {
		window.parent.postMessage(
		  {
			type: "NOTIFICATION",
			...payload,
		  },
		  "*"
		);
	  };
  
  

	return { token, stampTomador, parentMessage, parentMessageVersion,notifyParent};
};